// src/components/Footer.js

import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2024 Power Tools Store. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
